import { WildcardPermission, type IPermission, type IUser } from '@condo/domain';

/**
 * Mirrors Cockpit `user.store` admin detection (`roles.some(r => r === 'admin')` on role binding names)
 * with extra tolerance for casing and global wildcard permissions from the authz role record.
 */
export function userHasAdminAccess(user: IUser | undefined): boolean {
    if (!user) {
        return false;
    }

    const bindings = user.roles;
    if (Array.isArray(bindings)) {
        for (const binding of bindings) {
            const name = binding.role?.name;
            if (name && name.toLowerCase() === 'admin') {
                return true;
            }
        }
    }

    const permissions = user.permissions;
    if (Array.isArray(permissions)) {
        const wildcard = WildcardPermission.All as IPermission;
        if (permissions.includes(wildcard)) {
            return true;
        }
    }

    return false;
}
